import React from 'react'
import PropTypes from 'prop-types'
import { Spacing50 } from 'styles/sharedStyle'
import { FadeInUpAnimationWrapper } from 'styles/animation'
import {
  ImageWrapper,
  LandscapeImage,
  PortraitImage,
  FullBleedImage,
  ImageCaption,
  Caption,
  Credit,
} from './Image.style'

const Image = ({ id, type, image, enableImageFadeIn, hideCaption }) => {
  const extraProps = {
    id,
  }
  if (!image) return null
  const { portrait, landscape, altText, caption, photoCredit } = image
  // DX-2459 check if portrait image is in fact portrait - if not display as landscape for mobile display
  const portraitAsLandscape = portrait?.gatsbyImageData?.height < 1
  return (
    <FadeInUpAnimationWrapper enabled={enableImageFadeIn}>
      <>
        {type === 'portrait' && portrait && (
          <PortraitImage
            image={portrait.gatsbyImageData}
            alt={altText}
            {...extraProps}
          />
        )}
        {type === 'landscape' && landscape && (
          <LandscapeImage
            image={landscape.gatsbyImageData}
            alt={altText}
            {...extraProps}
          />
        )}
        {type === 'fullbleed' && landscape && portrait && (
          <ImageWrapper
            {...extraProps}
            portraitAsLandscape={portraitAsLandscape}>
            {portrait && (
              <FullBleedImage
                image={portrait.gatsbyImageData}
                display={['block', null, 'none']}
                alt={altText}
              />
            )}
            {landscape && (
              <FullBleedImage
                image={landscape.gatsbyImageData}
                display={['none', null, 'block']}
                alt={altText}
              />
            )}
          </ImageWrapper>
        )}
      </>
      {(caption || photoCredit) && !hideCaption && (
        <ImageCaption type={type} hideCaption>
          <Caption uppercase>{caption}</Caption>
          <Credit uppercase>{photoCredit}</Credit>
        </ImageCaption>
      )}
      <Spacing50 />
    </FadeInUpAnimationWrapper>
  )
}

Image.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string.isRequired,
  enableImageFadeIn: PropTypes.bool,
  hideCaption: PropTypes.bool,
  image: PropTypes.shape({
    portrait: PropTypes.shape({
      gatsbyImageData: PropTypes.shape({
        aspectRatio: PropTypes.number.isRequired,
        src: PropTypes.string.isRequired,
        srcSet: PropTypes.string.isRequired,
        srcSetWebp: PropTypes.string.isRequired,
        sizes: PropTypes.string.isRequired,
        height: PropTypes.number.isRequired,
      }).isRequired,
    }),
    landscape: PropTypes.shape({
      gatsbyImageData: PropTypes.shape({
        aspectRatio: PropTypes.number.isRequired,
        src: PropTypes.string.isRequired,
        srcSet: PropTypes.string.isRequired,
        srcSetWebp: PropTypes.string.isRequired,
        sizes: PropTypes.string.isRequired,
        height: PropTypes.number.isRequired,
      }).isRequired,
    }),
    caption: PropTypes.string,
    photoCredit: PropTypes.string,
    altText: PropTypes.string,
  }).isRequired,
}

Image.defaultProps = {
  id: undefined,
  enableImageFadeIn: false,
  hideCaption: false,
}

export default Image
